module.exports = __webpack_public_path__ + "static/media/polandTagsMobileLarge.333df938.png";